export function isSpecialCharContains(str) {
    const regName = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if(regName.test(str)) {
        return true
    }

    return false;
}